import { atom } from 'nanostores';

export interface ActiveGenerationInfo {
  id: string;
  urlId: string | null;
  description: string | null;
}

/**
 * The user's single in-flight generation, if any (one-at-a-time cap).
 * Source of truth for per-thread "generating" badges and the cap-block check.
 * Kept current by ActiveGenerationProvider (polls /api/chat/active) and nudged
 * locally when a send starts so the badge appears without waiting for a poll.
 */
export const $activeGeneration = atom<ActiveGenerationInfo | null>(null);
